import React from "react";
import { useRole } from "@/hooks/useRole";
import { Routes, Route, Navigate, useMatch } from "react-router-dom";
import { Loader2 } from "lucide-react";

// Import the page components
import Disponibilidade from "./mentor/Disponibilidade";
import MinhasMentorias from "./mentor/MinhasMentorias";
import SessoesVendidas from "./mentor/SessoesVendidas";
import SessoesCompradas from "./mentor/SessoesCompradas";
import MeusConteudosComprados from "./mentor/MeusConteudosComprados";
import Perfil from "./mentor/Perfil";
import Financas from "./mentor/Financas";
import DetalhesVendas from "./mentor/DetalhesVendas";
import Chat from "./shared/Chat";
import MinhasAvaliacoes from "./mentor/MinhasAvaliacoes";

// Import das páginas de comunidades
import ComunidadesMentor from "./mentor/ComunidadesMentor";
import ComunidadesQueParticipo from "./mentor/ComunidadesQueParticipo";
import CriarComunidade from "./mentor/CriarComunidade";
import EditarComunidade from "./mentor/EditarComunidade";
import DashboardComunidade from "./mentor/DashboardComunidade";

// Página de conteúdos digitais removida - agora integrada em MinhasMentorias

const MentorPanel = () => {
  const { role, loading } = useRole();
  const isRootPath = useMatch("/painel-mentor");
  
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader2 className="h-12 w-12 text-[#00B6F0] animate-spin" />
      </div>
    );
  }
  
  // Só redireciona se não está carregando E o role não é mentor
  // Isso evita redirecionamento durante o carregamento inicial
  if (!loading && role !== "mentor") {
    return <Navigate to="/" replace />;
  }
  
  return (
    <div className="min-h-screen bg-[#131922] pb-8 pt-24 p-6">
      <Routes>
        {/* Redireciona a rota raiz para perfil */}
        <Route path="/" element={<Navigate to="/painel-mentor/perfil" replace />} />
        <Route path="/disponibilidade" element={<Disponibilidade />} />
        <Route path="/minhas-mentorias" element={<MinhasMentorias />} />
        <Route path="/sessoes-vendidas" element={<SessoesVendidas />} />
        <Route path="/sessoes-compradas" element={<SessoesCompradas />} />
        <Route path="/conteudos-comprados" element={<MeusConteudosComprados />} />
        <Route path="/minhas-avaliacoes" element={<MinhasAvaliacoes />} />
        <Route path="/financas" element={<Financas />} />
        <Route path="/financas/detalhes-vendas" element={<DetalhesVendas />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/chat/:conversationId" element={<Chat />} />
        <Route path="/perfil" element={<Perfil />} />
        
        {/* Rota dos Conteúdos Digitais removida - integrada em /minhas-mentorias */}
        
        {/* Rotas das Comunidades */}
        <Route path="/comunidades" element={<ComunidadesMentor />} />
        <Route path="/comunidades-participo" element={<ComunidadesQueParticipo />} />
        <Route path="/comunidades/criar" element={<CriarComunidade />} />
        <Route path="/comunidades/:id/editar" element={<EditarComunidade />} />
        <Route path="/comunidades/:id/dashboard" element={<DashboardComunidade />} />
      </Routes>
    </div>
  );
};

export default MentorPanel;
